// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","wrapper":"_1d6w686ZGP_s","item":"_2OwkBzTu1y02"};